<div class="flex items-center space-x-4">
    <svg
        class="w-6 flex-shrink-0 fill-green"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.3304 9.91752C17.63 9.63151 17.641 9.15677 17.355 8.85714C17.069 8.55752 16.5943 8.54648 16.2946 8.83248L17.3304 9.91752ZM10.3958 15.5L9.87794 16.0425C10.1678 16.3192 10.6238 16.3192 10.9137 16.0425L10.3958 15.5ZM7.70536 11.895C7.40574 11.609 6.93099 11.62 6.64499 11.9196C6.35898 12.2193 6.37002 12.694 6.66964 12.98L7.70536 11.895ZM16.2946 8.83248L9.87794 14.9575L10.9137 16.0425L17.3304 9.91752L16.2946 8.83248ZM10.9137 14.9575L7.70536 11.895L6.66964 12.98L9.87794 16.0425L10.9137 14.9575ZM21.75 12C21.75 17.3848 17.3848 21.75 12 21.75V23.25C18.2132 23.25 23.25 18.2132 23.25 12H21.75ZM12 21.75C6.61522 21.75 2.25 17.3848 2.25 12H0.75C0.75 18.2132 5.7868 23.25 12 23.25V21.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25V0.75C5.7868 0.75 0.75 5.7868 0.75 12H2.25ZM12 2.25C17.3848 2.25 21.75 6.61522 21.75 12H23.25C23.25 5.7868 18.2132 0.75 12 0.75V2.25Z" />
    </svg>
    <p>
        {{ inclusion }}
    </p>
</div>
